import Compose from './Compose.vue';

export default Compose;
